import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { PoolCard } from './Pool';
import { ImageComponent } from '@/components/Image';
import {
  getTotalSumWithCurrency,
  updatePoolsWithPrizes,
} from '@/helpers/jackpot';
import { useCommonStore } from '@/store';

import { ScJackpotSection } from './styled';

export const JackpotSection = () => {
  const activeJackpot = useCommonStore.use.activeJackpot();
  const { t } = useTranslation('jackpot');

  const updatedPoolsWithPrizes = useMemo(
    () =>
      activeJackpot?.levels &&
      updatePoolsWithPrizes(activeJackpot.levels, activeJackpot.currency, t),
    [activeJackpot, t]
  );

  return (
    <ScJackpotSection>
      <div className="content">
        <div className="logo">
          <ImageComponent
            src="/jackpot/logo.webp"
            alt="jackpot logo"
            width={364}
            height={184}
            priority
          />
        </div>
        <div className="text">
          <div className="title">{t('totalPrizePool')}</div>
          {activeJackpot?.levels && (
            <div className="prize">
              {getTotalSumWithCurrency(
                activeJackpot.levels,
                activeJackpot.currency
              )}
            </div>
          )}
        </div>
      </div>
      <div className="pools">
        {updatedPoolsWithPrizes &&
          updatedPoolsWithPrizes?.map((pool, i) => (
            <PoolCard {...pool} key={i} />
          ))}
      </div>
    </ScJackpotSection>
  );
};
